/**
 * @param {Object}        params
 * @param {string}        params.savePath
 * @param {string}        params.inputName
 * @param {boolean}       params.multiple
 * @param {Array<Object>} params.attachments
 * @param {Object}        params.$link       - jQuery objekt tlačítka
 */
export function saveSelection({savePath, inputName, multiple, attachments, $link}) {
    if (!attachments.length) {
        return;
    }

    const dataValue = multiple
        ? attachments.map(att => att.id)
        : attachments[0].id;

    jQuery.ajax({
        url: savePath,
        type: 'POST',
        dataType: 'json',
        data: {[inputName]: dataValue},
        beforeSend: () => toggleButtonLoading($link[0], true),
        success: (json) => {
            toggleButtonLoading($link[0], false);
            console.log('Uloženo:', json);

            const url = $link.attr('data-wp-load');
            const target = $link.attr('data-wp-target');

            if (url !== undefined && target !== undefined) {
                jQuery(target).load(url);
            }

            if (json?.data?.message) {
                const cls = json.success ? 'alert-success' : 'alert-danger';
                const ico = json.success ? 'fa-circle-check' : 'fa-circle-exclamation';
                jQuery('#alert').prepend(
                    `<div class="alert ${cls} alert-dismissible fade show" role="alert">
                        <i class="fa-solid ${ico}"></i> ${json.data.message}
                        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
                    </div>`
                );
            }
        },
        error: (xhr) => {
            toggleButtonLoading($link[0], false);
            console.error('wp-media save error:', xhr.responseText);
        },
    });
}
